import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/elements/Button';
import CopyTextM from '../../components/elements/CopyTextM';
import Headline from '../../components/elements/Headline';
import './ConfirmationDialog.scss';
import Input from '../../components/elements/Input';

class ConfirmationDialog extends Component {
  render() {
    const { heading, text, confirmLabel, cancelLabel, onConfirm, onCancel, customInput } = this.props;

    return (
      <div className="confirmation-dialog">
        <Headline text={heading} />
        <div className="confirmation-dialog__text">
          <CopyTextM text={text} />
        </div>
        {customInput && (
          <div className="confirmation-dialog__input">
            <Input
              type="text"
              name="email"
              label={customInput.placeholder}
              value={customInput.value}
              onChange={(e) => customInput.onChange(e)}
            />
          </div>
        )}
        <div className="confirmation-dialog__actions">
          <Button layout="primary" label={confirmLabel} onClick={onConfirm} />
          <Button layout="secondary" label={cancelLabel} onClick={onCancel} />
        </div>
      </div>
    );
  }
}

ConfirmationDialog.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  customInput: PropTypes.shape({
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }),
};

ConfirmationDialog.defaultProps = {
  heading: '',
  text: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  onConfirm: () => {},
  onCancel: () => {},
  customInput: null,
};

export default ConfirmationDialog;
